import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import React, {useEffect, useState} from "react";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {deleteGallery, getGalleries} from "../../actions/Galleries";
import { IMAGE_URL } from "../../path";

interface Gallery {
    id: number;
    title: string;
    date_posted: Date;
    cover_image: string;
}

function ViewGalleries() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [galleries, setGalleries] = useState<Gallery[]>([]);

    const navigate = useNavigate();
    const fetchGalleries = () => {
        getGalleries()
            .then(response => {
                setGalleries(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch galleries:", error);
            })
    }

    async function handleDelete(galleryId: number) {
        try {
            await deleteGallery(galleryId);
            fetchGalleries();
        } catch (error: any) {
            // You might want to show this error to the user through some UI component
            console.error('Failed to delete gallery:', error.response?.data?.message || 'An error occurred');
            // If you have an error state, you can set it here
            // setError(error.response?.data?.message || 'Failed to delete gallery');
        }
    }

    useEffect(() => {
        fetchGalleries();
    }, []);

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="content-form-button right-align">
                    <button
                        type="button"
                        className="button button-right"
                        onClick={() => navigate('/dashboard/galleries/new', { state: { user } })}
                    >
                        Add New Gallery
                    </button>
                </div>
                <div className="table-container">
                    <table className="home-images-table">
                        <thead>
                        <tr>
                            <th style={{ width: '40%' }}>Title</th>
                            <th style={{ width: '20%' }}>Date Posted</th>
                            <th style={{ width: '20%' }}>Cover Image</th>
                            <th style={{ width: '20%' }}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {galleries.length > 0 ? (
                            galleries.map((gallery) => (
                                <tr key={gallery.id}>
                                    <td>{gallery.title}</td>
                                    <td>{new Date(gallery.date_posted).toLocaleDateString()}</td>
                                    <td>
                                        {gallery.cover_image ? (
                                            <img
                                                src={IMAGE_URL + gallery.cover_image}
                                                alt={gallery.title}
                                                style={{ width: '80px', height: '60px', objectFit: 'cover' }}
                                            />
                                        ) : (
                                            'No Image'
                                        )}
                                    </td>
                                    <td>
                                        {/*<button*/}
                                        {/*    className="button small"*/}
                                        {/*    // onClick={() => navigate('/dashboard/', { state: { user, image } })}*/}
                                        {/*    style={{ marginRight: "10px" }}*/}
                                        {/*>*/}
                                        {/*    Preview*/}
                                        {/*</button>*/}
                                        <button
                                            className="button small"
                                            onClick={() => navigate(`/dashboard/galleries/${gallery.id}/edit`, { state: { user } })}
                                            style={{ marginRight: "10px", marginBottom: '10px' }}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className="button small danger"
                                            style={{color: "black" }}
                                            onClick={() => handleDelete(gallery.id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={4} style={{ textAlign: 'center' }}>No galleries found</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )


}

export default ViewGalleries;
